module.exports = __webpack_public_path__ + "static/media/changeInfo.cdd48a16.svg";